const exist = (x: any) => {
  return typeof x !== 'undefined';
};

/**
 * 获取到对应元素的可移动范围
 */
export const getArea = (siders?: LayoutBoxSiderbounds) => {
  if (!siders) return {};
  if (exist(siders?.siderX)) {
    return {
      ex: siders!.siderX,
    };
  }
  if (exist(siders?.siderY)) {
    return {
      ey: siders!.siderY,
    };
  }
  return {};
};

/**
 * 判断是否在sider内
 */
export const isInSider = (
  x: number,
  y: number,
  siders?: LayoutBoxSiderbounds,
) => {
  if (!siders) return false;
  if (exist(siders.siderX)) {
    return x >= siders.siderX!;
  }
  if (exist(siders.siderY)) {
    return y >= siders.siderY!;
  }
  return false;
};

/**
 * 判断是否不在sider内
 */
export const isNotInSider = (
  x: number,
  y: number,
  siders?: LayoutBoxSiderbounds,
) => {
  if (!siders) return true;
  if (exist(siders.siderX)) {
    return x < siders.siderX!;
  }
  if (exist(siders.siderY)) {
    return y < siders.siderY!;
  }
  return true;
};

/**
 * sider内部的元素x, or y
 */
export const getSiderXY = (siders?: LayoutBoxSiderbounds) => {
  if (!siders) return {};
  if (exist(siders?.siderX)) {
    return {
      x: siders!.siderX,
    };
  }
  if (exist(siders?.siderY)) {
    return {
      y: siders!.siderY,
    };
  }
  return {};
};

/**
 * 判断sider位置
 */
export const isSiderRight = (siders?: LayoutBoxSiderbounds) => {
  return exist(siders?.siderX);
};
